import type { MockAthlete } from './types';

const firstNames = {
    M: [
        'Marco',
        'Luca',
        'Alessandro',
        'Matteo',
        'Francesco',
        'Riccardo',
        'Davide',
        'Lorenzo',
        'Gabriele',
        'Andrea',
        'Tommaso',
        'Filippo'
    ],
    F: [
        'Giulia',
        'Sofia',
        'Martina',
        'Chiara',
        'Sara',
        'Beatrice',
        'Alice',
        'Federica',
        'Valentina',
        'Ilaria',
        'Giorgia',
        'Elisa'
    ]
};
const lastNames = [
    'Bianchi',
    'Rossi',
    'Verdi',
    'Ferrari',
    'Esposito',
    'Romano',
    'Colombo',
    'Ricci',
    'Marino',
    'Greco',
    'Bruno',
    'Gallo',
    'Conti',
    'De Luca',
    'Costa',
    'Giordano',
    'Rizzo',
    'Lombardi',
    'Moretti',
    'Barbieri',
    'Fontana',
    'Santoro',
    'Mariani',
    'Rinaldi',
    'Caruso'
];

function categoryOf(year: number, gender: 'M' | 'F'): { code: string; label: string } {
    const age = 2026 - year;
    if (age <= 13) return { code: 'R', label: 'Ragazzi' };
    if (age <= 15) return { code: 'J', label: 'Juniores' };
    if (age <= 17) return { code: 'C', label: 'Cadetti' };
    if (age <= 19) return { code: 'S', label: 'Seniores' };
    return { code: gender === 'M' ? 'A' : 'A', label: 'Assoluti' };
}

const specialties = [
    'SL 100m',
    'DO 200m',
    'RA 100m',
    'FA 50m',
    'MX 200m',
    'SL 50m',
    'SL 400m',
    'DO 100m',
    'RA 200m',
    'FA 100m'
];

export const mockAthletes: MockAthlete[] = Array.from({ length: 25 }, (_, i) => {
    const gender: 'M' | 'F' = i % 2 === 0 ? 'F' : 'M';
    const birthYear = 2005 + (i % 12);
    const cat = categoryOf(birthYear, gender);
    const firstName = firstNames[gender][i % firstNames[gender].length];
    const lastName = lastNames[i % lastNames.length];
    return {
        id: `athlete-${i + 1}`,
        finId: `FIN${100000 + i * 37}`,
        firstName,
        lastName,
        gender,
        birthYear,
        categoryCode: cat.code,
        categoryLabel: cat.label,
        teamId: 'team-1',
        joinedAt: `202${3 + (i % 3)}-0${1 + (i % 9)}-15`,
        specialty: specialties[i % specialties.length],
        bestEvent: specialties[i % specialties.length],
        activeMacrocycle: i % 3 === 0 ? 'Preparazione Primavera 2026' : undefined
    };
});

export const mockAthleteSelf: MockAthlete = {
    id: 'athlete-self',
    finId: 'FIN987654',
    firstName: 'Giulia',
    lastName: 'Bianchi',
    gender: 'F',
    birthYear: 2008,
    categoryCode: 'C',
    categoryLabel: 'Cadette',
    teamId: 'team-1',
    joinedAt: '2022-09-01',
    specialty: 'SL 100m',
    bestEvent: 'SL 100m',
    activeMacrocycle: 'Preparazione Primavera 2026'
};
